import React from 'react';
import styled from 'styled-components';
import type { ProductRegimeProductModel } from 'autogen/swagger/all';
import Select from 'components/shared/inputs/select/Select';
import type IOption from 'components/shared/inputs/select/shared/types/option';
import { GA4Tracking } from 'modules/tracking/GA4/GA4Tracking';
import { useRegime } from './Regime';

const VariantContainer = styled.div`
    display: flex;
`;

const StyledSelect = styled(Select)`
    width: 100%;
`;

export default function RegimeVariantSelector({ product, ...restProps }: { product: ProductRegimeProductModel }) {
    const { replaceProduct, isSelected } = useRegime();
    const { variants } = product;
    const { id } = product.product;

    if (!variants) return null;

    // The reason we dont pass variants directly to the select, is because we want to disable the variantOptions that are already selected in the regime.
    const variantsFormatted = variants.reduce<IOption[]>((results, variant) => {
        const { productId, variantDisplayName } = variant;
        const isProductCurrentVariant = id === productId;
        const isVariantSelectedInRegime = isSelected(productId);

        if (!isProductCurrentVariant && isVariantSelectedInRegime) {
            results.push({ value: productId.toString(), label: variantDisplayName, disabled: true });
        } else {
            results.push({ value: productId.toString(), label: variantDisplayName });
        }

        return results;
    }, []);

    const selectedOption = variantsFormatted.find((option: IOption) => option.value === id.toString());

    return (
        <VariantContainer {...restProps}>
            <StyledSelect
                name="variant"
                value={selectedOption}
                size="md"
                onChange={(option: IOption) => {
                    replaceProduct(id, Number(option.value));

                    GA4Tracking({
                        eventName: 'choose_variant',
                        context: 'product_page',
                        category: 'ecommerce'
                    });
                }}
                options={variantsFormatted}
            />
        </VariantContainer>
    );
}
